import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import Cleave from 'vue-cleave-component';
import Vuelidate from 'vuelidate';
import RpsBraintree from '@pharmpress/vue-rps-braintree';
import Buefy from '@/plugins/buefy';
import App from './App.vue';
import store from './store';

Vue.use(Vue2TouchEvents);
Vue.use(Vuelidate);
Vue.use(Cleave);
Vue.use(Buefy);
Vue.use(RpsBraintree);

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* eslint no-extend-native: "warn" */
/* eslint no-bitwise: "warn" */
/* eslint no-param-reassign: "warn" */
Object.defineProperty(String.prototype, 'startsWith', {
  value(search, rawPos) {
    const pos = rawPos > 0 ? rawPos | 0 : 0;
    return this.substring(pos, pos + search.length) === search;
  },
});
String.prototype.endsWith = function (search, thisLen) {
  let thatLength = thisLen;
  if (thatLength === undefined || thatLength > this.length) {
    thatLength = this.length;
  }
  return this.substring(thatLength - search.length, thatLength) === search;
};

const searchParams = new URLSearchParams(window.location.search);
let memberCategory;

if (searchParams.has('membershipCategory')) {
  memberCategory = searchParams.get('membershipCategory');
}

// start vue after window is fully loaded to enable the api to call dnn
// servicesFramework to get tabId and rft
window.addEventListener('load', () => {
  // set the userAgent as an attribute in the html element
  document.documentElement.dataset.browser = navigator.userAgent;

  let devUserId = -1;
  window.dataLayer = window.dataLayer || [];

  if (process.env.NODE_ENV === 'development') {
    const userInfo = JSON.parse(window.sessionStorage.getItem('dnn-user'));
    if (userInfo) {
      document.getElementById('userEmail').value = userInfo.email;
      devUserId = userInfo.userId;
    } else {
      document.getElementById('userEmail').value = '';
    }
  }

  new Vue({
    store,
    render: (h) => h(App, {
      props: {
        dataLayer: window.dataLayer,
        navBar: document.querySelector('#breadcrumbbar'),
        enableBraintreeFeature: document.querySelector('#enableBraintreeFeature').value.toLowerCase() === 'true',
        enableDirectDebit: document.querySelector('#enableDirectDebit').value.toLowerCase() === 'true',
        clientTokenApi: document.querySelector('#dnnPaymentClientTokenRoute').value,
        paymentSubmissionApi: document.querySelector('#dnnPaymentSubmissionRoute').value,
        logApi: document.querySelector('#dnnPaymentLogRoute').value,
        paymentOptionsInfo: decodeURIComponent(document.querySelector('#dnnPaymentOptionsInfo').value),
        paymentOptionsInfoInternationalStudent: decodeURIComponent(document.querySelector('#dnnPaymentOptionsInfoInternationalStudent').value),
        devUserId,
        memberCategory,
      },
    }),
  }).$mount('#app');
});
